module.exports = {
  prismicRepo: `${process.env.MARINE_FLEX_PRISMIC_REPOSITORY}`,
  prismicAccessToken: `${process.env.MARINE_FLEX_PRISMIC_API_KEY}`,
  defaultLanguage: 'en-au',
  defaultLanguageName: 'en',
}
